import { render } from "./contact.vue?vue&type=template&id=4f445d7e&scoped=true"
const script = {}

import "./contact.vue?vue&type=style&index=0&id=4f445d7e&lang=scss&scoped=true"
import "./contact.vue?vue&type=style&index=1&id=4f445d7e&lang=css"
script.render = render
script.__scopeId = "data-v-4f445d7e"

export default script